<template>
  <el-dialog :title="$t('shareReading.add.title')" :visible.sync="dialogVisible" width="50%" @close="handleClose">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item :label="$t('shareReading.add.meter')" prop="fsmId">
        <el-select v-model="form.fsmId" :placeholder="$t('shareReading.add.selectMeter')" style="width:100%"
          @change="handleMeterChange">
          <el-option v-for="(item, index) in floorShares" :key="index" 
            :label="`${item.meterPosition} - ${item.meterNum}`"
            :value="item.fsmId" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('shareReading.add.preDegrees')" prop="preDegrees">
        <el-input v-model="form.preDegrees" :placeholder="$t('shareReading.add.inputPreDegrees')" />
      </el-form-item>
      <el-form-item :label="$t('shareReading.add.curDegrees')" prop="curDegrees">
        <el-input v-model="form.curDegrees" :placeholder="$t('shareReading.add.inputCurDegrees')" />
      </el-form-item>
      <el-form-item :label="$t('shareReading.add.preReadingTime')" prop="preReadingTime">
        <el-date-picker v-model="form.preReadingTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
          :placeholder="$t('shareReading.add.selectPreTime')" style="width:100%" />
      </el-form-item>
      <el-form-item :label="$t('shareReading.add.curReadingTime')" prop="curReadingTime">
        <el-date-picker v-model="form.curReadingTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
          :placeholder="$t('shareReading.add.selectCurTime')" style="width:100%" />
      </el-form-item>
      <el-form-item :label="$t('shareReading.add.readingPeriod')" prop="readingPeriod">
        <el-date-picker v-model="form.readingPeriod" type="month" value-format="yyyy-MM"
                        :placeholder="$t('shareReading.add.selectReadingPeriod')" style="width:100%" />
      </el-form-item>
      <el-form-item :label="$t('shareReading.add.remark')">
        <el-input v-model="form.remark" type="textarea" :placeholder="$t('shareReading.add.inputRemark')" :rows="3" />
      </el-form-item>

      <el-form-item :label="$t('shareReading.add.photo')" prop="photos">
        <upload-image-url ref="uploadImageUrl" @notifyUploadCoverImage="handleNotifyUploadCoverImage" />
        <div class="upload-tip">{{ $t('shareReading.add.photoRequired') }}</div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="handleSubmit">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { saveFloorShareReading, listFloorShareMeter } from '@/api/fee/shareReadingApi'
import UploadImageUrl from '@/components/upload/UploadImageUrl'

export default {
  name: 'AddShareReading',
  components: {
    UploadImageUrl
  },
  data() {
    return {
      dialogVisible: false,
      floorShares: [],
      form: {
        fsmId: '',
        preDegrees: '',
        curDegrees: '',
        preReadingTime: '',
        curReadingTime: '',
        remark: '',
        readingPeriod: '',
        communityId: '',
        floorId: '',
        unitId: '',
        photos: []
      },
      rules: {
        fsmId: [
          { required: true, message: this.$t('shareReading.validate.selectMeter'), trigger: 'change' }
        ],
        preDegrees: [
          { required: true, message: this.$t('shareReading.validate.inputPreDegrees'), trigger: 'blur' },
          { pattern: /^\d+(\.\d+)?$/, message: this.$t('shareReading.validate.number'), trigger: 'blur' }
        ],
        curDegrees: [
          { required: true, message: this.$t('shareReading.validate.inputCurDegrees'), trigger: 'blur' },
          { pattern: /^\d+(\.\d+)?$/, message: this.$t('shareReading.validate.number'), trigger: 'blur' }
        ],
        preReadingTime: [
          { required: true, message: this.$t('shareReading.validate.selectPreTime'), trigger: 'change' }
        ],
        curReadingTime: [
          { required: true, message: this.$t('shareReading.validate.selectCurTime'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    getCurrentYearMonth() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      return `${year}-${month}`
    },
    async open(floorId, unitId) {
      this.form.floorId = floorId || ''
      this.form.unitId = unitId || ''
      this.form.readingPeriod = this.getCurrentYearMonth()
      this.dialogVisible = true
      this.getFloorShares()
    },
    async getFloorShares() {
      try {
        const params = {
          page: 1,
          row: 300,
          communityId: getCommunityId()
        }
        // 根据传入的floorId和unitId进行过滤
        if (this.form.floorId) {
          params.floorId = this.form.floorId
        }
        if (this.form.unitId) {
          params.unitId = this.form.unitId
        }
        const { data } = await listFloorShareMeter(params)
        this.floorShares = data
      } catch (error) {
        console.error('获取公摊表列表失败:', error)
      }
    },
    handleMeterChange(val) {
      const selectedMeter = this.floorShares.find(item => item.fsmId === val)
      if (selectedMeter) {
        this.form.preDegrees = selectedMeter.curDegree
        this.form.preReadingTime = selectedMeter.curReadingTime
        this.form.floorId = selectedMeter.floorId || ''
        this.form.unitId = selectedMeter.unitId || ''
      }
    },
    handleNotifyUploadCoverImage(photosUrl) {
      this.form.photos = photosUrl
      // 触发表单验证
      this.$refs.form.validateField('photos')
    },
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            this.form.communityId = getCommunityId()
            await saveFloorShareReading(this.form)
            this.$message.success(this.$t('shareReading.message.addSuccess'))
            this.dialogVisible = false
            this.$emit('success')
          } catch (error) {
            console.error('添加公摊抄表失败:', error)
            this.$message.error(error.message || this.$t('shareReading.message.addFailed'))
          }
        }
      })
    },
    handleClose() {
      this.$refs.form.resetFields()
      this.form = {
        fsmId: '',
        preDegrees: '',
        curDegrees: '',
        preReadingTime: '',
        curReadingTime: '',
        remark: '',
        readingPeriod: this.getCurrentYearMonth(),
        communityId: '',
        floorId: '',
        unitId: '',
        photos: []
      }
      // 清空上传组件
      if (this.$refs.uploadImageUrl) {
        this.$refs.uploadImageUrl.clearImages()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
}
</style>
